// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xo4m","newExpiryDate":"styles_newExpiryDate__3iml8","footer":"styles_footer__2zIk7"};